import {useState} from 'react'
import useApi from '../../../services/useApi'
import { useParams } from 'react-router-dom'

export default function useBadgeProductOperations() {
  const [isLoading, setLoading] = useState(false)
  const Api = useApi()
  const {id} = useParams()

  const deleteProductBadge = (productIds: string[]) => {
    return Api.delete(
      `/products/product-badges/${id}/product-details`,
      {product_ids: productIds},
      {
        setLoading,
        successMessage: 'Product badge deleted successfully',
        refetch: `badge-products-${id}`,
      }
    )
  }

  return {
    deleteProductBadge,
    isOperationLoading: isLoading,
  }
}
